var classActiveCta = 'active-cta';
var element = document.querySelector('.wls-sticky-bar-wrapper');
var isInViewport = function (elem) {
    var rect = elem.getBoundingClientRect();
    return (
        rect.bottom >= 0 &&
        rect.right >= 0 &&
        rect.top <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.left <= (window.innerWidth || document.documentElement.clientWidth)
    );
};

var debounce = function (func, delay) {
    var timeout;
    return function () {
        var context = this;
        var args = arguments;
        clearTimeout(timeout);
        timeout = setTimeout(function () {
            func.apply(context, args);
        }, delay);
    };
};

var handleScroll = function () {
    var targetSections = [
        document.querySelector('.wls-lp-hero'),
        document.querySelector('.wls-choice'),
        document.querySelector('.wls-footer')
    ];

    var isAnySectionInView = targetSections.some(function (section) {
        return section && isInViewport(section);
    });

    if (isAnySectionInView) {
        element.classList.remove(classActiveCta);
    } else {
        element.classList.add(classActiveCta);
    }
};

var debouncedScroll = debounce(handleScroll, 50); // Adjust the debounce delay as needed

window.addEventListener('scroll', debouncedScroll);

// Call handleScroll once to show the button on load
window.addEventListener('load', function () {
    handleScroll();
});

